// ChemistryCalculatorsList.js
import React from "react";
import { chemistryCalculators } from "./ConstantsChemistryCalculator";
import SharedHelmet from ".././Helmet";
const TITLE =
  "Kalkulator Kimia - Kalkulator Gratis untuk Menghitung Massa Molar, Massa Besi, Massa Air, Volume Gas, dan Volume Sampel.";
const DESCRIPTION =
  "Jelajahi kumpulan kalkulator kimia gratis, termasuk kalkulator untuk berbagai massa dan berbagai volume zat.";
const KEYWORDS =
  "kalkulator massa besi, kalkulator massa molar, kalkulator massa air, kalkulator volume gas, kalkulator volume sampel";
const OG_URL = "https://do-calculate.com/id/chemistry-calculators/";
function ChemistryList() {
  return (
    <div className="container ">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >Kalkulator</th>
            <th >Deskripsi</th>
          </tr>
        </thead>
        <tbody>
          {chemistryCalculators.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default ChemistryList;